import { useState, useCallback } from 'react';
import { message } from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import ButtonConfirm from './ButtonConfirm';
import request from '@/request';

export default function Operator({
  record,
  title = '',
  onEdit,
  onRemove,
  removeAPI,
}) {
  const [loading, setLoading] = useState(false);

  const handleRemove = useCallback(async () => {
    setLoading(true);
    try {
      await request.delete(`${removeAPI}/${record.id}`);
      onRemove?.();
      message.success('删除成功');
    } catch (error) {
      console.error('请求失败:', error);
    } finally {
      setLoading(false);
    }
  }, [removeAPI, record.id, onRemove]);

  return (
    <div className="space-x-2">
      {onEdit && (
        <button
          onClick={onEdit}
          className="text-blue-600 hover:text-blue-800 hover:bg-blue-50 transition-colors duration-200 rounded cursor-pointer p-1"
          title="编辑"
        >
          <EditOutlined className="text-lg" />
        </button>
      )}
      {removeAPI && (
        <ButtonConfirm
          title={`移除${title}`}
          description={`确认移除${title}${record.name}?`}
          onConfirm={handleRemove}
          disabled={loading}
        >
          <button
            disabled={loading}
            className={`cursor-pointer ${
              loading
                ? 'text-gray-400 cursor-not-allowed'
                : 'text-red-600 hover:bg-red-50 cursor-pointer'
            }`}
            title="移除"
          >
            {loading ? (
              <LoadingOutlined className="text-lg" />
            ) : (
              <DeleteOutlined className="text-lg" />
            )}
          </button>
        </ButtonConfirm>
      )}
    </div>
  );
}
